import React from "react"
import { StaticLayout } from "../components/StaticLayout"

const Tos = () => (
  <StaticLayout headingText="Terms and Conditions">

  </StaticLayout>
)

export default Tos